import React from 'react';

export default function Diamond() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-diamond-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z" />
    </svg>
  );
}
